import { useRouteError } from "react-router";
import Header from "@core/layouts/header/Header";
import Footer from "@core/layouts/footer/Footer";
import Heading from "@core/components/title/Heading";
import { Button } from "@core/components/ui/Button";
import { useUiStore } from "@core/stores/uiStore";
import ImportChunkError from "@core/layouts/error/custom/ImportChunkError";
import { CircleX } from "lucide-react";

// Router Error 발생 시 페이지 리로드
export default function ErrorPage() {
  const isPcView = useUiStore((state) => state.isPcView());
  const error = useRouteError();

  return (
    <>
      <Header />
      <div className="flex min-h-[400px] flex-col items-center justify-center gap-[30px] lg:min-h-[600px]">
        <CircleX className="stroke-point-600 size-[50px] lg:size-[80px]" />
        <Heading level={isPcView ? 1 : 3}>일시적인 오류로 페이지를 불러올 수 없습니다.</Heading>
        {error instanceof ImportChunkError ? (
          <Button variant="bgPoint600" size="large" onClick={() => window.location.reload()}>
            새로고침
          </Button>
        ) : (
          <>{`${error}`}</>
        )}
      </div>
      <Footer />
    </>
  );
}
